<template>
    <div>
        <b-modal
            :no-close-on-backdrop="true" 
            scrollable 
            centered 
            size="xl"  
            @hide="this.emitEventCancel"
            :id="ModalIdAuditClinicalNote" 
            :title="this.dialogTitle"  
            :ok-title="$t('Shared.Close')" 
            @ok="this.emitEventCancel" 
            style="padding:none!important" 
            ok-only
        >
            <b-row>
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
                        <div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ this.$t('AuditList.Resume') }}</h6>
                            </div>
                            <div class="flex-container">
                                <div class="row">
                                    <div class="col-md-4" v-if="!showHistory">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.UserName') }}</small><br>
                                            <b>{{ this.userName }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.NotesId') }}</small><br>
                                            <b>{{ this.entityKeyValue2 }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.HeaderId') }}</small><br>
                                            <b>{{ this.entityKeyValue }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="!showHistory">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('Shared.Date') }}</small><br>
                                            <b>{{ this.date }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="!showHistory">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.Address') }}</small><br>
                                            <b>{{ this.address }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('Shared.PatientName') }}</small><br>
                                            <b>{{ this.patientName }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>

            <b-row v-if="!showHistory">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
                        <div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ title }}</h6>
                            </div>
                            <div class="flex-container" v-for="(item, index) in this.items(this.value)" :key="`ENTITY-${index}`">
                                <div class="row" v-if="item.name === 'NotesHeaderTable' && item.values.length != 0">
                                    <div class="col-md-12">
                                        <div class="float-left col text-muted p-item">
                                            <b>{{ $t('AuditList.Header').toUpperCase() }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-for="(control, i) in item.values" :key="`header-${index}-${i}`">
                                        <component
                                            :is="'TIssAuditNoteHeader'"
                                            :key="`header-${index}-${i}`"
                                            v-bind:id="`header-${index}-${i}`"
                                            v-bind:control="control"
                                        >
                                        </component>
                                    </div>
                                </div>
                                <div class="row" v-if="item.name === 'NotesTherapyTable' && item.values.length != 0">
                                    <div class="col-md-12">
                                        <div class="float-left col text-muted p-item">
                                            <b>{{ $t('AuditList.Billing').toUpperCase() }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-for="(control, i) in item.values" :key="`billing-${index}-${i}`">
                                        <component
                                            :is="'TIssAuditNoteBilling'"
                                            :key="`billing-${index}-${i}`"
                                            v-bind:id="`billing-${index}-${i}`"
                                            v-bind:control="control"
                                        >
                                        </component>
                                    </div>
                                </div>
                                <div class="row" v-if="item.name === 'NotesDetailTable' || item.name === 'NotesDetailGNTable'">
                                    <div class="col-md-12">
                                        <div class="float-left col text-muted p-item">
                                            <b>{{ noteDetailTitle.toUpperCase() }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-for="(control, i) in auditableControlsFilter(item.values)" :key="`DETAIL--${index}${i}`">
                                        <component
                                            :is="control.controlType"
                                            :key="control.controlId"
                                            v-bind:id="control.controlId"
                                            v-bind:control="control"
                                        >
                                        </component>
                                    </div>
                                </div>
                                <div class="row" v-if="item.name === 'NotesTableDetailTable'">
                                    <div class="float-left col text-muted" > 
                                        <b>{{ $t('AuditList.Tables').toUpperCase() }}</b>
                                    </div>
                                    <div class="col-md-12">
                                        <component
                                            :is="'TIssFormTable'"
                                            :key="item.tableId"
                                            v-bind:id="item.tableId"
                                            v-bind:control="item.values"
                                            v-bind:showOnlyChange="!showAllCellTable"
                                            v-bind:auditableTableControl="auditableTableControl()"
                                        >
                                        </component>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>

            <b-row v-else>
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
						<div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ $t('AuditList.History') }}</h6>
							</div>
                            <div class="flex-container">
                                <Timeline :value="EntityHistory" align="alternate" class="customized-timeline">
                                    <template #marker="slotProps">
                                        <span >
                                            <i :class="slotProps.item.icon" :style="'color: '+ slotProps.item.color + '; font-size: 1.5rem;'"></i>
                                        </span>
                                    </template>
                                    <template #content="slotProps">
                                        <div class="card mt-4">
                                            <div class="card-header">
                                                <div class="float-left col text-muted">
                                                    <small>{{ $t('Shared.Date') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.sysDate }}</b>
                                                </div>
                                                <div class="float-left col text-muted">
                                                    <small>{{ $t('AuditList.UserName') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.userName }}</b>
                                                </div>
                                                <div class="float-left col text-muted">
                                                    <small>{{ $t('AuditList.Address') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.ipAddress }}</b>
                                                </div>
                                                <div class="float-left col text-muted">
                                                    <small>{{  $tc('Shared.ActionsTxt') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.actionTrans }}</b>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="float-left col text-muted mb-2" v-for="(item, index) in items(slotProps.item)" :key="`HIST-${index}`">
                                                    <template v-if="item.name === 'NotesHeaderTable' && item.values.length != 0">
                                                        <div class="float-left col text-muted" > 
                                                            <b>{{ $t('AuditList.Header').toUpperCase() }}</b>
                                                        </div>
                                                        <div v-for="(control, i) in item.values" :key="`header-${index}-${i}`">
                                                            <component
                                                                :is="'TIssAuditNoteHeader'"
                                                                :key="`header-${index}-${i}`"
                                                                v-bind:id="`header-${index}-${i}`"
                                                                v-bind:control="control"
                                                            >
                                                            </component>
                                                        </div>
                                                    </template>
                                                    <template v-if="item.name === 'NotesTherapyTable' && item.values.length != 0">
                                                        <div class="float-left col text-muted p-item">
                                                            <b>{{ $t('AuditList.Billing').toUpperCase() }}</b>
                                                        </div>
                                                        <div v-for="(control, i) in item.values" :key="`billing-${index}-${i}`">
                                                            <component
                                                                :is="'TIssAuditNoteBilling'"
                                                                :key="`billing-${index}-${i}`"
                                                                v-bind:id="`billing-${index}-${i}`"
                                                                v-bind:control="control"
                                                            >
                                                            </component>
                                                        </div>
                                                    </template>
                                                    <template v-if="item.name === 'NotesDetailTable' || item.name === 'NotesDetailGNTable'">
                                                        <div class="float-left col text-muted" >                                                        
                                                            <b>{{ noteDetailTitle.toUpperCase() }}</b>
                                                        </div>

                                                        <div v-for="(control, i) in auditableControlsFilter(item.values)" :key="`HITEM--${index}${i}`">
                                                            <component
                                                                :is="control.controlType"
                                                                :key="control.controlId"
                                                                v-bind:id="control.controlId"
                                                                v-bind:control="control"
                                                            >
                                                            </component>
                                                        </div>
                                                    </template>
                                                    <template v-if="item.name === 'NotesTableDetailTable'">
                                                        <div class="float-left col text-muted" > 
                                                            <b>{{ $t('AuditList.Tables').toUpperCase() }}</b>
                                                        </div>
                                                        <div >
                                                            <component
                                                                :is="'TIssFormTable'"
                                                                :key="item.tableId"
                                                                v-bind:id="item.tableId"
                                                                v-bind:control="item.values"
                                                                v-bind:showOnlyChange="!showAllCellTable"
                                                                v-bind:auditableTableControl="auditableTableControl()"
                                                            >
                                                            </component>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </Timeline>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>

            <template #modal-footer>
                <b-button v-if="containTables"
                    variant="primary"
                    @click="emitShowTable"
                >
                    {{ showAllCellTable ? $t('AuditClinicalNote.HideAllCellTable') :  $t('AuditClinicalNote.ShowAllCellTable') }}
                </b-button>
                <b-button
                    variant="primary"
                    @click="emitShowHistory"
                >
                    {{ showHistory ? $t('AuditList.HideHistory') :  $t('AuditList.ShowHistory') }}
                </b-button>
                <b-button
                    variant="primary"
                    @click="emitEventCancel"
                >
                    {{ $t('Shared.Close') }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Utils from '@/common/utils'
import AuditUtils from '@/components/pages/audit/AuditUtils.js'
import ClinicalService from '@/services/clinical.service' 
import AuditService from '@/services/audit.service'
import { EventBus } from '@/event-bus.js';
import TIssEdit from '@/components/pages/audit/AuditNoteWithContent'
import TIssMemo from '@/components/pages/audit/AuditNoteWithContent'
import TIssHtmlEditor from '@/components/pages/audit/AuditNoteWithContent'
import TIssCheckListBox from '@/components/pages/audit/AuditNoteCheckListBox'
import TIssCheckBox from '@/components/pages/audit/AuditNoteCheckBox'
import TIssRadioGroup from '@/components/pages/audit/AuditNoteRadioGroup'
import TIssComboBox from '@/components/pages/audit/AuditNoteWithContent'
import TIssDateTimePicker from '@/components/pages/audit/AuditNoteWithContent'
import TIssFormTable from '@/components/pages/audit/AuditNoteTable'
import TIssSignatureCapture from '@/components/pages/audit/AuditNoteSignatureCapture'
import TIssImageEditor from '@/components/pages/audit/AuditNoteSignatureCapture'
import TIssAuditNoteHeader from '@/components/pages/audit/AuditNoteHeader'
import TIssAuditNoteBilling from '@/components/pages/audit/AuditNoteBilling'
import ShowMessage from '@/components/messages/ShowMessage.js'

export default {
    name: 'AuditClinicalNoteDialog',
    mixins: [ShowMessage],

    props: {
        VisibleDialog:Boolean,
        value: Object
    },

    components: {
        TIssEdit, TIssMemo, TIssCheckListBox, TIssHtmlEditor,
        TIssCheckBox, TIssRadioGroup, TIssComboBox, TIssDateTimePicker,
        TIssFormTable, TIssSignatureCapture, TIssAuditNoteHeader,
        TIssAuditNoteBilling, TIssImageEditor
    },

    data() {
        return {
            ModalIdAuditClinicalNote: 'ModalIdAuditClinicalNote',
            allProperties: false,
            auditableControls: [],
            lastEntity: {
                keyValue: null,
                keyValue2: null,
                keyValue3: null
            },
            showHistory: false,
            EntityHistory: [],
            showAllCellTable: false
        };
    },

    watch: {
        VisibleDialog(newVal) {
            if (newVal) {
                this.$bvModal.show(this.ModalIdAuditClinicalNote);
            }
        },

        value(newVal) {
            if (newVal && newVal.entityName && (this.lastEntity.keyValue != newVal.entityKeyValue || this.lastEntity.keyValue2 != newVal.entityKeyValue2 || this.lastEntity.keyValue3 != newVal.entityKeyValue3)) {
                EventBus.$emit('ShowWeel', true); 
                this.auditableControls = [];
                ClinicalService
                    .getAuditableControls(newVal.entityKeyValue2)
                    .then((response) => {
                        if (response.data) {
                            this.auditableControls = response.data;
                            this.lastEntity = {
                                keyValue: newVal.entityKeyValue,
                                keyValue2: newVal.entityKeyValue2,
                                keyValue3: newVal.entityKeyValue3
                            };
                        }
                        EventBus.$emit('ShowWeel', false);
                    })
                    .catch(error => {      
                        EventBus.$emit('ShowWeel', false); 
                        this.showResponseErrorMessage(error);
                    });
            }
        }
    },

    computed: {
        dialogTitle() {
            return this.value ? `${this.$t('Shared.AuditTitle')}: ${this.value.moduleTrans??this.value.entityType??''}` : this.$t('Shared.AuditTitle');
        }, 

        title() {
            return this.value ? `${this.$t('AuditList.Info')}: ${this.value.actionTrans}` : '';
        },

        date() {
            return this.value ? this.value.sysDate : '';
        },

        address() {
            return this.value ? this.value.ipAddress : '';
        },

        userName() {
            return this.value?.userName ?? '';
        },

        entityName() {
            return this.value?.entityName ?? '';
        },

        noteDetailTitle() {
            return this.$t('AuditClinicalNote.NoteDetailTitle');
        },

        patientName() {
            return this.value?.patientName ?? '';
        },

        entityKeyValue() {
            return this.value?.entityKeyValue ?? '';
        },

        entityKeyValue2() {
            return this.value?.entityKeyValue2 ?? '';
        },

        payload() {
            return this.value?.payload ?? {};
        },

        containTables() {
            if (this.showHistory) {
                return this.EntityHistory.find(x => x.payload.indexOf('{"NotesTableDetailTable":') != -1) != undefined;
            }

            if (this.value?.payload) {
                return this.value.payload.indexOf('{"NotesTableDetailTable":') != -1;
            }

            return false;
        }
    },

    methods: {
        emitEventCancel() {
            this.$bvModal.hide(this.ModalIdAuditClinicalNote);
            this.allProperties = false;
            this.showHistory = false;
            this.EntityHistory = [];
            this.showAllCellTable = false;
            this.$emit('close');
        },

        auditableTableControl() {
            return this.auditableControls
                    .filter(x => x.controlType == 'TIssFormTable')
                    .map(x => {
                        return {
                                controlId: x.controlId, 
                                name: x.entityName
                            };
                    });
        },

        auditableControlsFilter(details) {
            let data = this.auditableControls
                            .filter(x => x.controlType != 'TIssFormTable' && details.find(y => y.controlId == `${x.controlId}`) != undefined)
                            .map(x => {
                                const val = details.find(y => y.controlId == `${x.controlId}`);
                                let valueContents = val?.valueContents;
                                if (!Utils.isNullOrEmptyString(valueContents)) {
                                    valueContents = valueContents.trim();
                                    if (x.controlType == 'TIssDateTimePicker') {
                                        valueContents = Utils.formatterDateToString(valueContents, 'MM/DD/YYYY');
                                    } else if (x.controlType == 'TIssComboBox' && valueContents.length > 1 && valueContents[0] == '"' && valueContents[valueContents.length - 1] == '"') {
                                        valueContents = valueContents.substr(1, valueContents.length - 2);
                                    }
                                }

                                let oldValueContents = val?.oldValueContents;
                                if (!Utils.isNullOrEmptyString(oldValueContents)) {
                                    oldValueContents = oldValueContents.trim();
                                    if (x.controlType == 'TIssDateTimePicker') {
                                        oldValueContents = Utils.formatterDateToString(oldValueContents, 'MM/DD/YYYY');
                                    } else if (x.controlType == 'TIssComboBox' && oldValueContents.length > 1 && oldValueContents[0] == '"' && oldValueContents[oldValueContents.length - 1] == '"') {
                                        oldValueContents = oldValueContents.substr(1, oldValueContents.length - 2);
                                    }
                                }
                                    
                                return {
                                    controlId: x.controlId, 
                                    isHtmlContent: val?.isHtmlContent,
                                    allValues: x.allValues, 
                                    controlType: x.controlType, 
                                    name: x.entityName,
                                    valueContents: valueContents,
                                    oldValueContents: oldValueContents,
                                    valueSelectedValues: val?.valueSelectedValues,
                                    oldValueSelectedValues: val?.oldValueSelectedValues,
                                    objectContents: val?.objectContents,
                                    oldObjectContents: val?.oldObjectContents,
                                    extension: val?.extension,
                                    oldExtension: val?.oldExtension,
                                    status: val?.status
                                };
                            });

            data = data.filter(x => !(x.status == 'NEW' &&
                                        (
                                            ((x.controlType == 'TIssEdit' || x.controlType == 'TIssMemo') && (x.valueContents= '\r\n')) || 
                                            (x.valueContents == '') ||
                                            ((x.controlType == 'TIssSignatureCapture' && x.objectContents == ''))
                                        )));

            return data;
        },

        items(item) {
            let data = [];
            if (item) {
                try {
                    const obj = JSON.parse(item.payload);
                    if (Array.isArray(obj)) {
                        obj.forEach(element => {
                            const value = this.parseItem(element, item.action);
                            if (value !== undefined) {
                                data.push(value);
                            }
                        })
                    } else {
                        const value = this.parseItem(obj, item.action);
                        if (value !== undefined) {
                            data.push(value);
                        }
                    }
                }
                catch {
                    //TODO
                }
            }

            const therapy = this.parseBilling(data.filter(x => x.name == 'NotesTherapyTable').map(x => x.values));
            data = data.filter(x => x.name != 'NotesTherapyTable');
            if (therapy) {
                data.push({name: 'NotesTherapyTable', order: 1, values: therapy});
            }
            
            return data.sort((a, b) => {
                return a.order < b.order ? -1 : a.order > b.order ? 1 : 0;
            });
        },

        parseItem(item, action) {
            let data = undefined;
            
            Object.keys(item).forEach((propertyName) => {
                let values = [];
                const entity = item[propertyName];
                if (propertyName === 'NotesHeaderTable') {
                    values = AuditUtils.parseEntity(propertyName, entity, action, this.allProperties);
                    data = {name: propertyName, order: 0, values: values};
                } else if (propertyName === 'NotesDetailTable' || propertyName === 'NotesDetailGNTable') {
                    if (Array.isArray(entity)) {
                        entity.forEach((e) => {
                            values = values.concat(this.parseDetailEntity(e, action));
                        });
                    } else {
                        values = this.parseDetailEntity(entity, action);
                    }
                    data = {name: propertyName, order: 2, values: values};
                } else if (propertyName === 'NotesTableDetailTable') {
                    if (Array.isArray(entity)) {
                        entity.forEach((e) => {
                            values = values.concat(this.parseTableEntity(e, action));
                        })
                    } else {
                        values = this.parseTableEntity(entity, action);
                    }
                    data = {name: propertyName, order: 3, values: values};
                } else if (propertyName === 'NotesTherapyTable') {
                    values = AuditUtils.parseEntity(propertyName, entity, action == 'WAA_UPDATE' ? 'WAA_NEW' : action, true);
                    data = {name: propertyName, order: 1, values: values};
                }                
            });

            return data;
        },

        parseTableEntity(entity, action) {
            let currentValue = [];
            let originalValue = [];
            
            Object.keys(entity).forEach((j) => {
                const value = entity[j];
                if (j == 'CurrentValue') {
                    Object.keys(value).forEach((k) => {
                        currentValue.push({name: k, value: value[k]});
                    })
                } else if (j == 'OriginalValue') {
                    Object.keys(value).forEach((k) => {
                        originalValue.push({name: k, value: value[k]});
                    })
                }
            });

            let values = [];
            if (action == 'WAA_INSERT') {
                let val = {
                    tableId: null,
                    headerId: currentValue.find(x => x.name == 'HeaderId')?.value,
                    recId: currentValue.find(x => x.name == 'RecId')?.value,
                    tableContents: AuditUtils.getTableFromXml(currentValue.find(x => x.name == 'TableContents')?.value),
                    oldTableContents: null,
                    status: 'NEW'
                };

                values.push(AuditUtils.createNoteTable(val));
            } else if (action == 'WAA_DELETE') {
                let val = {
                    tableId: originalValue.find(x => x.name == 'TableId')?.value,
                    headerId: originalValue.find(x => x.name == 'HeaderId')?.value,
                    recId: originalValue.find(x => x.name == 'RecId')?.value,
                    tableContents: null,
                    oldTableContents: AuditUtils.getTableFromXml(originalValue.find(x => x.name == 'TableContents')?.value),
                    status: 'DELETE'
                };

                values.push(AuditUtils.createNoteTable(val));
            } else {
                const tableContents = currentValue.find(x => x.name == 'TableContents');
                const oldTableContents = originalValue.find(x => x.name == 'TableContents');
                if (this.allProperties || tableContents || oldTableContents) {
                    let val = {
                        tableId: currentValue.find(x => x.name == 'TableId')?.value,
                        headerId: currentValue.find(x => x.name == 'HeaderId')?.value,
                        recId: currentValue.find(x => x.name == 'RecId')?.value,
                        tableContents: AuditUtils.getTableFromXml(tableContents?.value),
                        oldTableContents: AuditUtils.getTableFromXml(oldTableContents?.value),
                        status: 'UPDATE'
                    };

                    values.push(AuditUtils.createNoteTable(val));
                }
            }
            
            return values;
        },

        parseDetailEntity(entity, action) {
            const defaultRichEditValue = '<div><p style="text-align:left">&nbsp;</p></div>';
            let currentValue = [];
            let originalValue = [];
            
            Object.keys(entity).forEach((j) => {
                const value = entity[j];
                if (j == 'CurrentValue') {
                    Object.keys(value).forEach((k) => {
                        currentValue.push({name: k, value: value[k]});
                    })
                } else if (j == 'OriginalValue') {
                    Object.keys(value).forEach((k) => {
                        originalValue.push({name: k, value: value[k]});
                    })
                }
            });

            let values = [];
            if (action == 'WAA_INSERT') {
                const isRichEditEmpty = (currentValue.find(x => x.name == 'IsHtmlContent')?.value == "Y" && currentValue.find(x => x.name == 'Contents')?.value == defaultRichEditValue)
                const currentContents = !Utils.isNullOrEmptyString(currentValue.find(x => x.name == 'Contents')?.value) && !isRichEditEmpty;
                const currentSelectedValues = !Utils.isNullOrEmptyString(currentValue.find(x => x.name == 'SelectedValues')?.value);
                const objectContents = !Utils.isNullOrEmptyString(currentValue.find(x => x.name == 'ObjectContents')?.value);
                if (this.allProperties || currentContents || currentSelectedValues || objectContents) {
                    if (currentValue.find(x => x.name == 'IsHtmlContent')?.value == "Y")
                        console.log(currentValue.find(x => x.name == 'Contents')?.value)
                    
                    let val = {
                        controlId: currentValue.find(x => x.name == 'ControlId')?.value,
                        isHtmlContent: currentValue.find(x => x.name == 'IsHtmlContent')?.value,
                        valueContents: currentValue.find(x => x.name == 'Contents')?.value,
                        oldValueContents: null,
                        valueSelectedValues: currentValue.find(x => x.name == 'SelectedValues')?.value,
                        oldValueSelectedValues: null,
                        objectContents: currentValue.find(x => x.name == 'ObjectContents')?.value,
                        oldObjectContents: null,
                        extension: currentValue.find(x => x.name == 'Extension')?.value,
                        oldExtension: null,
                        status: 'NEW'
                    };
                    
                    values.push(val);
                }
            } else if (action == 'WAA_DELETE') {
                const isRichEditEmpty = (originalValue.find(x => x.name == 'IsHtmlContent')?.value == "Y" && originalValue.find(x => x.name == 'Contents')?.value == defaultRichEditValue)
                const originalContents = !Utils.isNullOrEmptyString(originalValue.find(x => x.name == 'Contents')?.value) && !isRichEditEmpty;
                const originalSelectedValues = !Utils.isNullOrEmptyString(originalValue.find(x => x.name == 'SelectedValues')?.value);
                const objectContents = !Utils.isNullOrEmptyString(originalValue.find(x => x.name == 'ObjectContents')?.value);
                if (this.allProperties || originalContents || originalSelectedValues || objectContents) {
                    let val = {
                        controlId: originalValue.find(x => x.name == 'ControlId')?.value,
                        isHtmlContent: originalValue.find(x => x.name == 'IsHtmlContent')?.value,
                        valueContents: null,
                        oldValueContents: originalValue.find(x => x.name == 'Contents')?.value,
                        valueSelectedValues: null,
                        oldValueSelectedValues: originalValue.find(x => x.name == 'SelectedValues')?.value,
                        objectContents: null,
                        oldObjectContents: originalValue.find(x => x.name == 'ObjectContents')?.value,
                        extension: null,
                        oldExtension: originalValue.find(x => x.name == 'Extension')?.value,
                        status: 'DELETE'
                    };

                    values.push(val);
                }
            } else {
                const originalContents = originalValue.find(x => x.name == 'Contents');
                const originalSelectedValues = originalValue.find(x => x.name == 'SelectedValues');
                const objectContents = originalValue.find(x => x.name == 'ObjectContents');
                if (this.allProperties || originalContents || originalSelectedValues || objectContents) {
                    let val = {
                        controlId: currentValue.find(x => x.name == 'ControlId')?.value,
                        isHtmlContent: currentValue.find(x => x.name == 'IsHtmlContent')?.value,
                        valueContents: currentValue.find(x => x.name == 'Contents')?.value,
                        oldValueContents: originalContents?.value,
                        valueSelectedValues: currentValue.find(x => x.name == 'SelectedValues')?.value,
                        oldValueSelectedValues: originalSelectedValues?.value,
                        objectContents: currentValue.find(x => x.name == 'ObjectContents')?.value,
                        oldObjectContents: objectContents?.value,
                        extension: currentValue.find(x => x.name == 'Extension')?.value,
                        oldExtension: originalValue.find(x => x.name == 'Extension')?.value,
                        status: 'UPDATE'
                    };

                    values.push(val);
                }
            }

            return values;
        },

        parseBilling(values) {
            if (values) {
                const therapyCodes = values.flat()
                                        .filter(x => x.name == 'Therapycode')
                                        .map(x => x.value != '' ? x.value : x.old);
                
                if (therapyCodes) {
                    const data = [];
                    let uniqueTherapyCodes = [...new Set(therapyCodes)];
                    uniqueTherapyCodes.forEach((element) => {
                        const billings = values.filter(x => x.find(y => y.name == 'Therapycode' && (y.value == element || y.old == element)) != undefined);
                        const units = [];
                        billings.forEach((billing) => {
                            const unit = billing.find(x => x.name == 'Units');
                            if (unit) {
                                units.push(unit);
                            }
                        });
                        data.push({name: element, units: units});
                    });
                    
                    return data;
                }
            }
            
            return undefined;
        },

        emitAllProperties() {
            this.allProperties = !this.allProperties;
        },

        emitShowTable() {
            this.showAllCellTable = !this.showAllCellTable;
        },

        emitShowHistory() {
            this.showHistory = !this.showHistory;
            if (this.showHistory) {
                EventBus.$emit('ShowWeel', true); 
                AuditService.getHistory(this.value.recId)
                    .then((response) => {
                        if (response.data && response.data.length > 0) {
                            this.EntityHistory = response.data;
                            this.EntityHistory.forEach((element) => {  
                                let { sysDate  } = element 
                                if (sysDate) element.sysDate = `${Utils.formatterDateTimeToString(sysDate)}`;
                                element.actionTrans = AuditUtils.translateAction(element.action);
                                element.moduleTrans = AuditUtils.translateModule(element.module);   
                                element.icon = element.recId == this.value.recId ? "mdi mdi-checkbox-marked-circle" :
                                    (element.action == 'WAA_INSERT' ? 'mdi mdi-plus-circle' : (element.action == 'WAA_UPDATE' ? 'mdi mdi-checkbox-blank-circle' : 'mdi mdi-minus-circle'));

                                element.color = element.action == 'WAA_INSERT' ? 'green' : (element.action == 'WAA_UPDATE' ? 'black' : 'red');
                            });
                        }
                        EventBus.$emit('ShowWeel', false); 
                    })
                    .catch((error) => {
                        EventBus.$emit('ShowWeel', false); 
                        this.showResponseErrorMessage(error);
                    })
            }
        },
    }
}
</script>